var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg39(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39_svg__a)",
    fill: "#EF4635"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.697 41.813c2.349-9.741-.44-10.075-.44-14.801 0-1.576 1.243-5.348 1.425-7.18.424-4.212-.621-3.091 2.454-6.212l.182-4.332c1.546-1.485 2.318-2.818 4.212-2.348 1.152 3.423-1.03 2.348-1.242 6.347 1.288 1.712 2.151 1.878 3.121 4.03 1.227 2.726.349 2.696 2.667 4.984 3.409.394 5.47.409 7.909-2.045.257-2.621-1.258-2.394.288-4.803 1.06-1.65 2.106-2.545 4.09-1.878.652 2.575-2.272 3.105-1.363 5.969 3.924.393 4.833-5.015 7.833-5.287 0 5.771-6.03 6.529-6.166 11.225-.091 2.939 2.515 11.028 5.151 12.755 2.318-3.56 4.818-7.438 5.106-11.74C47.94-2.862 9.091-8.21 1.712 17.498A20.19 20.19 0 0 0 1 21.483v3.408c.652 8.453 5.864 15.876 9.697 16.922Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.06 45.752c10.5 1.242 9.395-2 7.319-13.953-.818-4.711-1.773-7.195-7.364-6.756-3.485 4.136-1.727 12.195-1.606 15.724.091 2.788-.379 2.97 1.652 4.985Zm12.076-2.879c1.758-.212 2.06-.575 3.485-1.712.227-2.408-1.424-6.286-4-7.059-1.212 2.333-.864 6.484.515 8.771Zm-17.303 2c0-2.939.364-9.014-1.151-11.104-2.015.59-1.394 2.318-1.41 5.999-.014 2.696-.514 4.832 2.561 5.105Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "39_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(1 1)",
    d: "M0 0h45v45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg39);
export default __webpack_public_path__ + "static/media/39.bbd7f7997daedd21a52de62ef0530ea6.svg";
export { ForwardRef as ReactComponent };